import { useSelector } from "react-redux";

const useLoyaltyCategory = () => {
  const user = useSelector(({ userData }) => userData.userData);

  const addons = user?.Addon__c?.split(";");
  const isPCD =
    addons?.find((addon) => addon?.toUpperCase() === "PCD") &&
    user?.LoyaltyCategory__c?.toLowerCase()?.includes("cabuloso");

  return `${user?.LoyaltyCategory__c}${isPCD ? ` - PCD` : ""}` || ``;
};

export default useLoyaltyCategory;
